/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Complete_Signin_MessageInputs */

const en_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A browser window has opened for you to sign in with Google. Please complete the sign-in process in your browser.`)
};

const fr_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fenêtre de navigateur s'est ouverte pour vous connecter avec Google. Veuillez terminer le processus de connexion dans votre navigateur.`)
};

const de_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es hat sich ein Browserfenster geöffnet, in dem Sie sich mit Google anmelden können. Bitte schließen Sie den Anmeldevorgang in Ihrem Browser ab.`)
};

const it_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è aperta una finestra del browser per accedere con Google. Completa la procedura di accesso nel tuo browser.`)
};

const ru_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открылось окно браузера, в котором вам нужно войти в систему Google. Пожалуйста, завершите процесс входа в систему в вашем браузере.`)
};

const es_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha abierto una ventana del navegador para que inicies sesión con Google. Completa el proceso de inicio de sesión en tu navegador.`)
};

const zh_cn2_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器窗口已打开，供您使用 Google 帐户登录。请在浏览器中完成登录过程。`)
};

const ja_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Googleでログインするためのブラウザウィンドウが開きました。ブラウザでログイン手続きを完了してください。`)
};

const hi_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके लिए Google से साइन इन करने हेतु एक ब्राउज़र विंडो खुल गई है। कृपया अपने ब्राउज़र में साइन इन प्रक्रिया पूरी करें।`)
};

const pt_pt2_login_complete_signin_message = /** @type {(inputs: Login_Complete_Signin_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma janela do navegador foi aberta para que você faça login com o Google. Conclua o processo de login no seu navegador.`)
};

/**
* | output |
* | --- |
* | "A browser window has opened for you to sign in with Google. Please complete the sign-in process in your browser." |
*
* @param {Login_Complete_Signin_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_complete_signin_message = /** @type {((inputs?: Login_Complete_Signin_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Complete_Signin_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_complete_signin_message(inputs)
	if (locale === "de") return de_login_complete_signin_message(inputs)
	if (locale === "it") return it_login_complete_signin_message(inputs)
	if (locale === "ru") return ru_login_complete_signin_message(inputs)
	if (locale === "es") return es_login_complete_signin_message(inputs)
	if (locale === "zh-CN") return zh_cn2_login_complete_signin_message(inputs)
	if (locale === "ja") return ja_login_complete_signin_message(inputs)
	if (locale === "hi") return hi_login_complete_signin_message(inputs)
	if (locale === "pt-PT") return pt_pt2_login_complete_signin_message(inputs)
	return en_login_complete_signin_message(inputs)
});